import { Platform } from "react-native";
import { MOCK_SERVER_PORT } from "./mockServerPort";

type Fetch = typeof fetch;

const TRANSLATIONS_URL = "https://cdn.dev.envs.lookiero.tech/i18n/";

const BODYLESS_METHODS: ReadonlySet<string> = new Set(["GET", "HEAD"]);

const isNativeTestVariant = Platform.OS !== "web" && process.env.EXPO_PUBLIC_APP_VARIANT === "test";

const mockServerOrigin = `http://${Platform.OS === "android" ? "10.0.2.2" : "localhost"}:${MOCK_SERVER_PORT}`;

const mockServerApiUrl = `${mockServerOrigin}/style-profile/api`;

const mockServerLookAndLikeApiUrl = `${mockServerOrigin}/lookandlike`;

const isRequest = (input: RequestInfo | URL): input is Request =>
  typeof Request !== "undefined" && input instanceof Request;

const urlOf = (input: RequestInfo | URL): string =>
  typeof input === "string" ? input : isRequest(input) ? input.url : input.toString();

const requestInit = async (request: Request): Promise<RequestInit> => ({
  method: request.method,
  headers: request.headers,
  credentials: request.credentials,
  signal: request.signal,
  body: BODYLESS_METHODS.has(request.method.toUpperCase()) ? undefined : await request.text(),
});

const redirectTranslations =
  (networkFetch: Fetch, origin: string): Fetch =>
  async (input, init) => {
    const url = urlOf(input);

    if (!url.startsWith(TRANSLATIONS_URL)) {
      return networkFetch(input, init);
    }

    const redirectedUrl = `${origin}/i18n/${url.slice(TRANSLATIONS_URL.length)}`;

    return networkFetch(redirectedUrl, isRequest(input) ? { ...(await requestInit(input)), ...init } : init);
  };

const redirectTranslationsToMockServer = (): void => {
  if (!isNativeTestVariant) {
    return;
  }

  globalThis.fetch = redirectTranslations(globalThis.fetch, mockServerOrigin);
};

export {
  TRANSLATIONS_URL,
  isNativeTestVariant,
  mockServerApiUrl,
  mockServerLookAndLikeApiUrl,
  mockServerOrigin,
  redirectTranslations,
  redirectTranslationsToMockServer,
};
